<template>
  <v-row justify="center" no-gutters>
    <v-col v-for="ad in ads" :key="ad" cols="auto px-3">
      <template v-if="ad === 0">
        <a href="https://px.a8.net/svt/ejp?a8mat=4B3WJ6+6TW1MA+25B2+61Z81" rel="nofollow">
          <img
            border="0"
            width="300"
            height="250"
            alt=""
            src="https://www23.a8.net/svt/bgt?aid=260522610413&wid=001&eno=01&mid=s00000010019001017000&mc=1"
          />
        </a>
        <img border="0" width="1" height="1" src="https://www15.a8.net/0.gif?a8mat=4B3WJ6+6TW1MA+25B2+61Z81" alt="" />
      </template>
      <template v-else-if="ad === 1">
        <a href="https://px.a8.net/svt/ejp?a8mat=4B3WJ6+6TAM0I+1WP2+15P77L" rel="nofollow">
          <img
            border="0"
            width="300"
            height="250"
            alt=""
            src="https://www23.a8.net/svt/bgt?aid=260522610412&wid=001&eno=01&mid=s00000008903007004000&mc=1"
          />
        </a>
        <img border="0" width="1" height="1" src="https://www14.a8.net/0.gif?a8mat=4B3WJ6+6TAM0I+1WP2+15P77L" alt="" />
      </template>
    </v-col>
  </v-row>
</template>
<script>
export default {
  computed: {
    ads() {
      return this.$vuetify.breakpoint.mobile ? [Math.round(Math.random())] : [0, 1]
    },
  },
}
</script>
